angular
  .module('statInsuranceMti')
  .component('statInsuranceMti', {
    template: require('./stat-insurance-mti.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function statInsuranceMtiController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'stat';
        $rootScope.menu = 'insurancemti';
        $scope.showOrderView = $rootScope.gShowOrderView;
        $scope.showUserView = $rootScope.gShowUserView;
        const APIURL = envService.read('apiUrl');

        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
         
        }

       

        this.listData = {};
        this.totalCount = 0;
        this.totalPrice = 0;

       
         var today = new Date();
         today.toISOString().substring(0, 10); 
          $resource(`${APIURL}/insurance_fetch/report`).query({}).$promise
          .then((data) => { 
             console.log("data"+data);
             this.listData = data; 
             data.forEach(element => {
               this.totalPrice +=  element.PRICE;
             });

             console.log("tota"+this.totalPrice);
             return Promise.resolve(); 
          
          })
          .catch((err) => {
            alert(err.data.msg);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });

          this.onDatePick = () => {
            const startDate = jQuery('#inputPickerStart').val();
            const endDate = jQuery('#inputPickerEnd').val();
            

                $resource(`${APIURL}/insurance_fetch/report?from_date=${startDate}&to_date=${endDate}`).query({}).$promise
                .then((data) => { 
                  console.log("data"+data);
                  this.listData = data; 
                  return Promise.resolve(); 
                
                })
                .catch((err) => {
                  alert(err.data.msg);
                  if (err.data && err.data.msg) {
                    alert(err.data.msg);
                  } else {
                    alert($translate.instant('알수 없는 에러 입니다.'));
                  }
                });

            };

            $scope.onExportExel = () => {
              const startDate = jQuery('#inputPickerStart').val();
              const endDate = jQuery('#inputPickerEnd').val();
              this.newPointEvent.startdate = moment(startDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
              this.newPointEvent.endDate = moment(endDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
    
              $window.open(`${APIURL}/insurance_fetch/report?from_date=${startDate}&to_date=${endDate}&export=1`, '_blank');
            };

         
      },
     
    ],
  });




// WEBPACK FOOTER //
// ./src/app/stat-insurance-mti/stat-insurance-mti.component.js